import React, {ReactElement} from "react";

export default function Topbar(): ReactElement {

	return <div id="topbar">
		<div className="title">
			<div className="zeeromed-logo"></div>
			<div>ZEEROmed Upload</div>
		</div>
	</div>
}